import { type CountryCodeReader, type RegionalBaseUrls } from "../constants";
import { getRegion } from "../gatewayRegion";

const emptyRegionalUrls = (): RegionalBaseUrls => ({
  IN: "",
  US: "",
  GCC: "",
});

const omsConfig: {
  oms: RegionalBaseUrls;
  oneOms: RegionalBaseUrls;
  readCountryCode: CountryCodeReader;
} = {
  oms: emptyRegionalUrls(),
  oneOms: emptyRegionalUrls(),
  readCountryCode: () => "",
};

export function configureOmsBaseUrls(
  oms: RegionalBaseUrls,
  oneOms: RegionalBaseUrls,
  countryCodeReader: CountryCodeReader,
): void {
  omsConfig.oms = oms;
  omsConfig.oneOms = oneOms;
  omsConfig.readCountryCode = countryCodeReader;
}

function resolveRegionalUrl(urls: RegionalBaseUrls): string {
  const region = getRegion(omsConfig.readCountryCode());
  return (urls[region] || urls.IN).replace(/\/$/, "");
}

export function getOmsIndiaApiUrl(): string {
  return omsConfig.oms.IN.replace(/\/$/, "");
}

export function getOmsApiUrl(): string {
  return resolveRegionalUrl(omsConfig.oms);
}

export function getOneOmsApiUrl(): string {
  return resolveRegionalUrl(omsConfig.oneOms);
}
